import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

const AutoValidateForm = ({ onValidated }) => {
  const { values, validateForm } = useFormikContext();

  useEffect(() => {
    validateForm().then(errors => onValidated(errors, values));
  }, [values, validateForm, onValidated]);

  return null;
};

AutoValidateForm.propTypes = {
  onValidated: PropTypes.func.isRequired,
};

export default AutoValidateForm;
